import { render, staticRenderFns } from "./ResolvedCard.vue?vue&type=template&id=431fbf97&scoped=true&lang=true&"
import script from "./ResolvedCard.vue?vue&type=script&lang=js&"
export * from "./ResolvedCard.vue?vue&type=script&lang=js&"
import style0 from "./ResolvedCard.vue?vue&type=style&index=0&id=431fbf97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431fbf97",
  null
  
)

export default component.exports